import { create } from 'zustand';

interface CanvasState {
  zoom: number;
  isPanMode: boolean;

  setZoom: (zoom: number | ((prev: number) => number)) => void;
  setIsPanMode: (on: boolean) => void;
}

export const useCanvasStore = create<CanvasState>()((set) => ({
  zoom: 1,
  isPanMode: false,

  setZoom: (arg) =>
    set((s) => ({
      zoom: typeof arg === 'function' ? arg(s.zoom) : arg,
    })),
  setIsPanMode: (isPanMode) => set({ isPanMode }),
}));
